module.exports = __webpack_public_path__ + "img/mobile_case2.75f51261.png";